import React from "react";
import { testimonials as tData } from "../../data/mock";
import { Quote, Star } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

export default function Testimonials() {
  const { t } = useLanguage();
  const items = t("testimonials.items") || [];

  return (
    <section id="testimonials" className="relative py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 hero-bg" />
      <div className="absolute inset-0 stars" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="kicker">{t("testimonials.kicker")}</span>
          <h2 className="mt-5 font-display text-4xl lg:text-5xl font-bold text-white">
            {t("testimonials.title1")} <span className="grad-text">{t("testimonials.titleAccent")}</span>
          </h2>
          <p className="mt-4 text-slate-300/90 text-lg">{t("testimonials.description")}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tData.map((tst, i) => {
            const localized = items[i] || {};
            const industry = localized.industry || tst.industry;
            const quote = localized.quote || tst.quote;
            const role = localized.role || tst.role;
            return (
              <div key={tst.author} className="glass lift rounded-2xl p-7 flex flex-col">
                <div className="flex items-center justify-between mb-4">
                  <span className="px-3 py-1 text-[10px] tracking-widest uppercase font-semibold rounded-full bg-cyan-500/15 border border-cyan-400/30 text-cyan-200">
                    {industry}
                  </span>
                  <Quote className="w-6 h-6 text-cyan-400/60" />
                </div>
                <p className="text-slate-200 leading-relaxed">“{quote}”</p>
                <div className="mt-6 pt-5 border-t border-white/10 flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full bg-gradient-to-br from-sky-500 to-cyan-400 flex items-center justify-center font-semibold text-white text-sm">
                    {tst.initials}
                  </div>
                  <div>
                    <div className="text-white font-semibold text-sm">{tst.author}</div>
                    <div className="text-slate-400 text-xs">{role}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-14 glass rounded-2xl p-6 flex flex-col md:flex-row items-center justify-center md:justify-between gap-6">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 text-cyan-300 fill-cyan-300" />
              ))}
            </div>
            <span className="font-display text-2xl font-bold text-white">4.9/5</span>
          </div>
          <div className="flex items-center gap-8 text-sm text-slate-300">
            <div><span className="grad-text font-semibold">500+</span> {t("testimonials.projectsDelivered")}</div>
            <div className="w-px h-5 bg-white/10" />
            <div><span className="grad-text font-semibold">98%</span> {t("testimonials.clientSatisfaction")}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
